<template>
  <div
    v-if="visibleProducts.length > 0"
    class="c-product-info__collection"
  >
    <h2
      v-if="collectionName"
      class="t-heading-7 u-margin-bottom-medium"
    >
      Shop {{ collectionName }}
    </h2>
    <div class="l-grid l-grid--3-col u-margin-bottom-medium">
      <div
        v-for="visibleProduct in visibleProducts"
        :key="visibleProduct.handle"
      >
        <product-image
          :src="visibleProduct | productImgUrl"
          :alt="visibleProduct | productImgAlt"
          size="160x160"
        />
      </div>
    </div>
    <div class="l-flex l-flex--justify-center">
      <btn
        :class-modifiers="buttonClassModifiers"
        :url="buttonUrl"
        @click="$emit('click', $event)"
        @focus.native="hover = true"
        @blur.native="hover = false"
      >
        Explore All Colors
      </btn>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get'
import Btn from '../button/Btn'
import ProductImage from '../productImage/ProductImage'

export default {
  components: {
    Btn,
    ProductImage
  },
  filters: {
    productImgUrl(product) {
      return get(product, 'featuredImage.src')
    },
    productImgAlt(product) {
      return get(product, 'featuredImage.alt')
    },
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    products: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      buttonClassModifiers: ['primary'],
    }
  },
  computed: {
    buttonUrl () {
      let handle = get(this.product, 'handle')
      return `/products/${handle}`
    },
    visibleProducts() {
      let results = []
      if (this.products.length > 3) results = this.products.slice(0, 3)
      else results = this.products

      return results
    },
    collectionName() {
      let value = this.product.metafieldsMap?.collection_label?.value
      return value ? value.replace('Collection', '').trim() : '';
    }
  }
}
</script>
<style lang="scss" scoped>
.c-product-info__collection {
  margin-top: rem(30px);
  border-top: 1px solid #ccd4d9;
  padding: rem(30px) 0;
}
</style>
